import { render, staticRenderFns } from "./CRT.vue?vue&type=template&id=f3b50544"
import script from "./CRT.vue?vue&type=script&lang=js"
export * from "./CRT.vue?vue&type=script&lang=js"
import style0 from "./CRT.vue?vue&type=style&index=0&id=f3b50544&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports